import * as types from './mutation-types.js'
import HF from './help-functions.js'
import * as mutationTypes from '@/store/mutation-types.js'
import router from '@/router/index.js'
import ST from '@/constants/server-types.js'
import axios from 'axios'

import bao from '@/mixins/basic-operations.js'
const basicOperations = bao.methods

const RS = require('@/services/rest.service.js')
var restService = new RS.default()
const helpFunctions = new HF()
const serverTypeConstants = new ST()
const instance = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
})
export const serverLocationPAth = function () {
  //production
  let path = window.location;

  let origin = path.origin;
  let pathname = path.pathname;
  let arrayPathname = pathname.split("/");
  let index = ''
  if (arrayPathname.length > 0) {

    index = arrayPathname.indexOf("webstudent");
  }
  if (index === -1 || index === '-1') {
    return origin


  } else {
    return origin + '/webstudent'
  }

  /****************dev */
  // return 'http://localhost/webstudent/'
  // return 'https://9db9b0e699fe.ngrok.io/webstudent/'
}

export const ping = function ({
  commit,
  state }, successCallback) {

  var restService = new RS.default() //eslint-disable-line
  console.log(successCallback)
  restService.GET('servertypeinfo', {}, successCallback)
}

export const login = function ({
  commit,
  state
}, payload) {
  let connection = payload.connection
  let successCallback = payload.successCallback
  // let failureCallback = payload.failureCallback
  let loginCallProperties = helpFunctions.getLoginCallProperties(connection, state.projectNaam, state.versienummer)
  const allowedToLogin = (resultRouter, usersType) => {
    commit(types.LOGGED_IN)
    commit(types.SET_USERS_TYPE, usersType)
    commit(types.SET_LOGGED_IN_USER_INFORMATION, resultRouter.data.result)

    commit(types.SET_LOGGED_IN_CONNECTION_OBJECT, connection)
    commit(types.IS_HEVERLEE_USER, connection.serverLocation)

    if (state.userInfo.isHeverleeUser) {
      commit(types.SET_EXTERNAL_LINK_FOR_EVALUATION)
    }
    successCallback(resultRouter)
  }
  const failedToLogin = (msg) => {
    console.log('fffffffff')
    commit(mutationTypes.UNLOCK_LOGIN_PROCEDURE)
    let errorMessage = 'Er kon geen verbinding worden gemaakt'
    if (typeof msg === 'string') {
      errorMessage = msg
    } else {
      try {
        errorMessage = msg.data.error.message
      } catch (e) {
        try {
          errorMessage = msg.response.statusText
        } catch (e) {
          errorMessage = 'Er kon geen verbinding worden gemaakt'
        }
      }
    }
    commit(types.SHOW_MESSAGE, errorMessage)
    // failureCallback(msg)
  }

  function loginViaRouter(counter) {
    instance.post(connection.serverLocation + '/bin/server.fcgi/RPC/ROUTER/', loginCallProperties)
      .then(function (resultRouter) {
        if (typeof resultRouter.data.error === 'undefined' || resultRouter.data.error === null) {
          setTimeout(function () {
            instance.get(connection.serverLocation + '/bin/server.fcgi/REST/servertypeinfo').then(function (resultServerType) {
              try {
                resultServerType = resultServerType.data.data[0].ServerType
              } catch (e) {
                resultServerType = resultServerType.data[0].ServerType
              }
              if (serverTypeConstants.isLeerkrachtenWebsite(resultServerType)) {
                console.log('it is leerkracht')
                if (typeof resultRouter.data.result.SessionConfig.PersoneelID === 'number') {
                  allowedToLogin(resultRouter, 'isLeerkracht')
                } else {
                  failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
                }
              } else if (serverTypeConstants.isVwoWebsite(resultServerType)) {
                console.log('it is VWO Login')
                if (typeof resultRouter.data.result.SessionConfig.PersoneelID === 'number') {
                  allowedToLogin(resultRouter, 'isVwoLogin')
                } else {
                  failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
                }
              }
              else if (serverTypeConstants.isVwoLLWebsite(resultServerType)) {
                console.log('it is STUDENT Login')
                instance.get(connection.serverLocation + '/bin/server.fcgi/REST/Leerling').then(function (resultLL) {
                  if (resultLL.data.data.length > 0 && resultRouter.data.result.UserData.userid === resultLL.data.data[0].UserID) {
                    commit(types.SET_LEERLING_ID, resultLL.data.data[0].ID)
                    allowedToLogin(resultRouter, 'isStudent')
                  }
                  else if (resultLL.data.data.length > 0 && resultRouter.data.result.UserData.userid === 0 && resultRouter.data.result.UserData.name === "Beheerder") {
                    commit(types.SET_LEERLING_ID, resultLL.data.data[0].ID)
                    allowedToLogin(resultRouter, 'isRootLogin')


                  } else {
                    failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
                  }

                })

                // if (typeof resultRouter.data.result.SessionConfig.PersoneelID === 'number') {
                //   allowedToLogin(resultRouter, 'isVwollLogin')
                // } else {
                //   failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
                // }
              }
              else if (serverTypeConstants.isLeerlingenWebsite(resultServerType)) {
                instance.get(connection.serverLocation + '/bin/server.fcgi/REST/Leerling').then(function (resultLL) {
                  if (resultLL.data.data.length > 0 && resultRouter.data.result.UserData.userid === resultLL.data.data[0].UserID) {
                    commit(types.SET_LEERLING_ID, resultLL.data.data[0].ID)
                    allowedToLogin(resultRouter, 'isLeerling')
                  } else {
                    failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
                  }
                })
              } else if (serverTypeConstants.isOudersWebsite(resultServerType)) {
                if (typeof resultRouter.data.result.SessionConfig.Rol === 'string') {
                  allowedToLogin(resultRouter, 'isOuder')
                } else {
                  failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
                }
              } else {
                failedToLogin('Opgegeven server en gebruikersnaam komen niet overeen')
              }
            }).catch(function (res) {
              try {
                if (res.response.status === 401 && counter < 3) {
                  counter = counter + 1
                  loginViaRouter(counter)
                } else {
                  failedToLogin(res)
                }
              } catch (e) {
                failedToLogin(res)
              }
            })
          }, 150 * (2 * counter))
        } else {
          failedToLogin(resultRouter.data.error.message)
        }
      })
      .catch(failedToLogin)
  }
  // console.log('connection? ' + navigator.connection.type === 'none')
  if (typeof navigator.connection !== 'undefined' && navigator.connection.type === 'none') {
    failedToLogin('Gelieve uw internet verbinding te controleren')
  } else {
    instance.get(connection.serverLocation + '/bin/server.fcgi/RPC/API/').then(function (res) {
      eval(res.data) // eslint-disable-line
      var API = eval(res.data)
      commit(types.SET_CURRENT_CONNECTION_API, API)
      basicOperations._setUserInfoTypeServer(state)
    })
    loginViaRouter(1)
  }
}

export const logoutProcedureForModuleStates = function ({
  commit,
  state
}, payload) {
  let aanwMutationTypes = require('wisaapp-webstudent/src/store/mutation-types.js')
  commit('wstudent/' + aanwMutationTypes.SET_STATE_TO_INITIAL_VALUES)
}

export const logoutProcedureForApp = function ({
  dispatch,
  state,
  commit
}, params) {
  commit(mutationTypes.SET_STATE_TO_INITIAL_VALUES)
  commit(mutationTypes.LOGGED_OUT_ONCE)
  commit(mutationTypes.SHOW_MESSAGE, 'Je bent afgemeld')
  commit(mutationTypes.SET_MENUBAR_ITEMS, {
    left: [],
    title: state.projectNaam,
    right: []
  })
  router.push('/')
}

export const logout = function ({
  dispatch,
  state,
  commit
},
  params) {
  var logoutRequest = {
    'action': 'WisaUserAPI',
    'method': 'Logout',
    'data': [],
    'type': 'rpc',
    'tid': '1'
  }

  var restService = new RS.default() //eslint-disable-line
  restService.POST(
    'RPC/ROUTER',
    logoutRequest,
    function () {
      dispatch('logoutProcedureForModuleStates')
      dispatch('logoutProcedureForApp')
    },
    function (resultRouter) {
      commit(mutationTypes.SHOW_MESSAGE, ['Fout : ' + resultRouter.error, 'error'])
      dispatch('logoutProcedureForModuleStates')
      dispatch('logoutProcedureForApp')
    },
    true,
    0,
    ''
  )
}


export const exportQuery = function ({
  dispatch,
  state
  // commit,
  // rootState
}, params) {

  var restService = new RS.default() //eslint-disable-line
  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [{
      resource: params.query,
      method: 'GET',
      api: 'query',
      parameters: {
        'pl': params.fields
      }
    }],
    function (res) {
      console.log('SUCCES')

      let resultaten = res[0].data.data
      if (resultaten !== undefined && resultaten.length > 0) {
        params.callback(resultaten)
      } else {
        params.callback('Geen resultaten gevonden voor exportQuery')
      }
    },
    function (res) {
      params.callback('Fout bij ophalen exportQuery')
    }
  )
}

export const createRequest = function ({
  // dispatch,
  state,
  commit,
  rootState
}, params) {

  var dit = params.dezeDit

  var datum = dit.user.Datum.split('-')

  var request = {
    resource: 'createrequest' + '?email=' + encodeURIComponent(dit.user.email) + '&PW=' + encodeURIComponent(dit.user.PW) + '&Koppelcode=' + dit.user.Koppelcode +
      '&Familienaam=' + encodeURIComponent(dit.user.Familienaam) + '&Voornaam=' + encodeURIComponent(dit.user.Voornaam) + '&Rol=' + dit.user.Rol.value +
      '&Geboortejaar=' + datum[0] + '&Geboortemaand=' + datum[1] + '&Geboortedag=' + datum[2] + '&PrivacyAccepted=' + dit.user.acceptPrivacy, //must create a checkbox for accepting terms
    method: 'POST',
    api: 'account'
  }

  if (dit.serverLocation !== undefined) {
    request.externalServer = serverLocationPAth() + '/bin/server.fcgi/account'//must doueble  check 
  }

  /*
  if (dit.serverLocation !== undefined) {
    request.externalServer = dit.serverLocation
  } else if (dit.serverLocationOfSelectedConnection !== undefined) {
    request.externalServer = dit.serverLocationOfSelectedConnection + 'bin/server.fcgi/account'
  } else 
  */
  //  if (dit.serverLocation !== undefined) { // 8080 testing
  //     request.externalServer = 'http://localhost/webstudent/'+ 'bin/server.fcgi/account'
  //   }


  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [request],
    function (res) {
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Mail met verzoek om je gebruiker aan te maken is succesvol verstuurd.', 'long'])

    },
    function (res) {

      // dit.$store.commit(mutationTypes.SHOW_MESSAGE, res.response.statusText)
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, 'Je gegevens (naam, voornaam, geboortedatum, e-mail adres en koppelcode) moeten overeenkomen met de gegevens van de school')

    }
  )
}

export const apiCheck = function ({
  // dispatch,
  state,
  commit,
  rootState
}, params) {
  var dit = params.dezeDit
  var request = {
    resource: 'API',
    method: 'GET',
    api: 'RPC'
  }

  if (dit.connectionObject !== undefined) { // 8080 testing
    request.externalServer = serverLocationPAth() + '/bin/server.fcgi/RPC'
  }
  if (dit.serverLocation !== undefined) {
    request.externalServer = serverLocationPAth() + '/bin/server.fcgi/RPC'//must doueble  check 
  }
  // request.externalServer = serverLocationPAth() + '/bin/server.fcgi/RPC' //dev

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [request],
    function (res) {
      var API = eval(res[0].data)
      commit(types.SET_CURRENT_CONNECTION_API, API)
      basicOperations._setUserInfoTypeServer(state)
      params.succesCallback()
    },
    function (res) {
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, 'Server locatie kon niet aangesproken worden.') // res.response.statusText
    }
  )
}

export const getConfirmationCode = function ({
  dispatch,
  state,
  commit,
  rootState
}, params) {
  var dit = params.dezeDit

  var request = {
    resource: 'confirmationcode' + '?Key=' + encodeURIComponent(dit.confirmationKey) + '&ID=' + encodeURIComponent(dit.confirmationID) + '&CCRecipient=' + dit.selectedEmailOrPhone.originalType,
    method: 'GET',
    api: 'account',
  }

  // if (dit.serverLocation !== undefined) { // 8080 testing
  request.externalServer = serverLocationPAth() + '/bin/server.fcgi/account'
  // }
  // Eigen url klopt niet, als externe zetten:
  // request.externalServer = window.location.href.split('vue/')[0] + 'bin/server.fcgi/account'

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [request],
    function (res) {
      console.log('getConfirmationCode SUCCESS')
      dit.activationCodeReceived = true
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Gelieve de ontvangen activatiecode in te geven.', 'long'])
    },
    function (res) {
      console.log('resetPasswordRequest FAILURE')
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Fout bij het ophalen van de activatiecode.', 'long'])
    }
  )
}
export const createConfirmation = function ({
  // dispatch,
  state,
  commit,
  rootState
}, params) {
  var dit = params.dezeDit
  // if (dit.serverLocation !== undefined) { // 8080 testing
  dit.huidigeServerLocatie = serverLocationPAth() + '/bin/server.fcgi/account' //dev
  // }

  var request = {
    resource: 'createconfirmation' + '?key=' + encodeURIComponent(dit.confirmationKey) + '&id=' + encodeURIComponent(dit.confirmationID) + '&ConfirmationCode=' + dit.activationCode,
    method: 'POST',
    api: 'account',
    externalServer: dit.huidigeServerLocatie
  }

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [request],
    function (res) {
      console.log('createconfirmation SUCCESS')
      dit.activationSuccess = true
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Je gebruiker is geactiveerd! Je wordt nu doorgestuurd naar de Schoolware login pagina.', 'long'])
      setTimeout(function () {
        // window.location.href = serverLocationPAth() //prod
        dit.$router.push('/')
        // window.location.href = 'http://localhost:8080/#/' //dev'
      }, 2000)

    },
    function (res) {
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, res.response.statusText)
    }
  )
}
/********************* */
// export const resetPasswordRequest = function({ dispatch, state, commit, rootState }, payload) {
//   return new Promise((resolve, reject) => {

//   restService.POST(
//     "account/resetpasswordconfirmation",
//     {
//       username: payload.dezeDit.username,

//     },
//     function(res) {

//       resolve(res)
//     },
//     undefined,
//     true,
//     0
//   );
// });
// }

/******************88888 */
export const resetPasswordRequest = function ({
  // dispatch,
  router,
  state,
  commit,
  rootState
}, params) {
  var dit = params.dezeDit
  if (rootState.userInfo.loggedInConnectionObject !== undefined && rootState.userInfo.loggedInConnectionObject !== null) {
    var username = rootState.userInfo.loggedInConnectionObject.username
  }
  if (username === undefined) { // connection scherm
    username = dit.username
  }
  username = encodeURIComponent(username)


  var request = {
    resource: 'resetpasswordrequest' + '?username=' + username,
    method: 'POST',
    api: 'account'

  }


  // if (dit.serverLocation !== undefined) {
  request.externalServer = serverLocationPAth() + '/bin/server.fcgi/account'//must doueble  check 
  // }
  // request.externalServer = serverLocationPAth() + 'bin/server.fcgi/account' //dev

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [request],
    function (res) {
      console.log('resetPasswordRequest SUCCESS')
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Hebben we je account kunnen vinden dan mag je binnen enkele ogenblikken een mail verwachten.', 'long'])
      setTimeout(function () {
        // window.location.href = dit.serverLocation + '/start.html'
        //  window.location.href =  dit.$router.push('/')//prod
        // window.location.replace(serverLocationPAth());
        dit.$router.push('/')
        //  window.location.href = 'http://localhost:8080/#/' //dev
      }, 4000)
    },
    function (res) {
      console.log('resetPasswordRequest FAILURE')
      console.log(res.response.statusText)
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Hebben we je account kunnen vinden dan mag je binnen enkele ogenblikken een mail verwachten.', 'long'])
      setTimeout(function () {
        // window.location.href = dit.serverLocation + '/start.html'
        //  window.location.href = dit.$router.push('/') //prod
        dit.$router.push('/')
        //  window.location.replace(serverLocationPAth());
        //  window.location.href = 'http://localhost:8080/#/' //dev
      }, 4000)
    }
  )
}
export const resetPasswordConfirmation = function ({
  // dispatch,
  router,
  state,
  commit,
  rootState
}, params) {
  var dit = params.dezeDit

  var request = {
    resource: 'resetpasswordconfirmation' + '?Key=' + encodeURIComponent(dit.Key) + '&ID=' + encodeURIComponent(dit.ID) + '&PW=' + encodeURIComponent(dit.PW),
    method: 'POST',
    api: 'account',
    /*parameters: {
      'username': encodeURIComponent(rootState.userInfo.loggedInConnectionObject.username)
    },*/
    /*customHeaders: [{
      type: 'POST',
      key: 'Accept-Charset',
      value: 'utf-8'
    }]*/
  }
  // if (dit.connectionObject !== undefined) { // connection scherm
  request.externalServer = serverLocationPAth() + '/bin/server.fcgi/account' // must double check
  // }

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [request],
    function (res) {
      console.log('ResetPasswordRequest SUCCESS')
      dit.wachtwoordVergetenSucces = true
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, ['Wachtwoord wijzigen geslaagd! Je wordt nu doorverwezen naar de Schoolware startpagina.', 'long'])
      setTimeout(function () {
        // window.location.href = dit.serverLocation + '/start.html'
        //  window.location.href =  dit.$router.push('/') //prod
        dit.$router.push('/')
        //  window.location.href = 'http://localhost:8080/#/' //dev
        // window.location.replace(serverLocationPAth());
      }, 4000)

    },
    function (res) {
      dit.$store.commit(mutationTypes.SHOW_MESSAGE, res.response.statusText)
    }
  )
}

export const getMySchoolwareAccount = function ({
  dispatch,
  state,
  commit,
  rootState
}, dit) {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [{
      resource: 'myschoolwareaccount',
      method: 'GET',
      api: 'REST',
      parameters: {
        /*'Naam':
        'VrijParam1':
        'Naamvolledig':*/
      }
    }],
    function (res) {
      console.log('SUCCES')
      dit.mySchoolwareAccount = res[0].data.data[0]
      dit.mySchoolwareAccountBACKUP = _.cloneDeep(dit.mySchoolwareAccount)
      dit.$forceUpdate()
      if (dit.successCallbackGetMySchoolwareAccount !== undefined) {
        dit.successCallbackGetMySchoolwareAccount()
      }
    },
    function (res) {
      commit(mutationTypes.SHOW_MESSAGE, ['Fout bij ophalen van myschoolwareaccount: ' + res.response.data.message, 'error'], {
        root: true
      })
    },
    true,
    0
  )
}
export const putMySchoolwareAccount = function ({
  dispatch,
  state,
  commit,
  rootState
}, dit) {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [{
      resource: 'myschoolwareaccount',
      action: '',
      method: 'PUT',
      methodAanroep: 'myschoolwareaccount',
      type: 'REST',
      tid: '1',
      api: 'REST',
      parameters: dit.mySchoolwareAccount
    }],
    function (res) {
      console.log('SUCCES')
      dit.res = res[0].data.data[0]
      dispatch('putMySchoolwareAccountIsSuccess', dit)
      setTimeout(function () {
        // window.location.href = dit.serverLocation + '/start.html'
        //  window.location.href =  dit.$router.push('/') //prod
        dit.$router.push('/')
        //  window.location.href = 'http://localhost:8080/#/' //dev
        // window.location.replace(serverLocationPAth());
      }, 1000)
    },
    function (res) {
      if (res.response !== undefined && res.response.statusText === 'Content not changed') {
        dit.res = JSON.parse(res.response.config.data)
        dispatch('putMySchoolwareAccountIsSuccess', dit)
      } else if (res.response === undefined || res.response.data.message === undefined) {
        commit(mutationTypes.SHOW_MESSAGE, ['Fout bij wijzigen gegevens: ' + res.message, 'error'], {
          root: true
        })
      } else {
        commit(mutationTypes.SHOW_MESSAGE, ['Fout bij wijzigen gegevens: ' + res.response.data.message, 'error'], {
          root: true
        })
      }
    },
    true,
    0
  )
}